import { createSlice } from '@reduxjs/toolkit';
import _ from "lodash";
import {sampleColors} from "../../utils/colors";


const initialState = {
    selectedAppdataIds: {
        blacklist: null,
        screen: null,
    },
    annotationsToRemove: [],
    componentStates: {},
    etfColors: {},
    builders: {},
    chartSeries: null,
    selectedChartPoints: [],  // New field for storing selected points
    selectedPortfolio: null,
    tickerGroup: null,
    chartGlobalDateRange: {
        start: null,
        end: null
    },
    comparison: {
        colors: {}
    },
    etfMatrix: {
        weights: {}
    },

};

const appStatesSlice = createSlice({
  name: 'appStates',
  initialState,
  reducers: {
    saveComponentState(state, action) {
      const { componentName, componentState } = action.payload;
      state.componentStates[componentName] = componentState;
    },
    clearComponentState(state, action) {
      const { componentName } = action.payload;
      if (state.componentStates[componentName]) {
        delete state.componentStates[componentName];
      }
    },
    saveBuilderState(state, action) {
      const { builderState } = action.payload;
      const stateId = builderState.stateId;
      state.builders[stateId] = builderState;
    },
    clearBuilderState(state, action) {
        const { stateId } = action.payload;
        if (state.builders[stateId]) {
            const newBuilders = {...state.builders};
            delete newBuilders[stateId];
            state.builders = newBuilders;
        }
    },

     mergeBuilderStates(state, action) {
        const { newBuilderState, mergedIds } = action.payload;
        // Add the new merged builder state
        state.builders[newBuilderState.stateId] = newBuilderState;
        // Remove merged drafts
        mergedIds.forEach(id => {
            if (state.builders[id]) {
                delete state.builders[id];
            }
        });
    },

    setSelectedChartPoints(state, action) {  // Reducer to set selected chart points
      state.selectedChartPoints = action.payload;
    },
    addSelectedChartPoint(state, action){
        state.selectedChartPoints = [...state.selectedChartPoints, action.payload]
    },
    resetAnnotationToRemove(state, action) {
        state.annotationsToRemove = [];
    },

      setTickerGroup(state, action) {
        state.tickerGroup = action.payload;
      },


      setEtfColors(state, action) {
        state.etfColors[action.payload.id] = action.payload.color;
      },
      setEtfWeight(state, action) {
          const { symbol, weight } = action.payload;
          const field = action.payload?.field ?? 'etfMatrix';
          console.log('setEtfWeight', symbol, weight, field)
          state[field].weights[symbol] = weight;
      },
      resetEtfWeights(state, action) {
        const field = action.payload?.field ?? 'etfMatrix';
        state[field].weights = {};
      },

      /**
       * Set a color for a comparison chart
       * @param action.payload { field, id, color }
       */
      setColor(state, action) {
          const { stateKey, id, color } = action.payload;
          console.log('setColor', stateKey, id, color)
          state[stateKey].colors[id] = color || sampleColors(1, 'dark')[0];
      },

  },
});

export const {
    saveComponentState,
    clearComponentState,
    saveBuilderState,
    clearBuilderState,
    addSelectedChartPoint,
    setSelectedChartPoints,
    resetAnnotationToRemove,
    setTickerGroup,
    setEtfColors,
    setEtfWeight,
    setColor,
    mergeBuilderStates
} = appStatesSlice.actions;

export const selectAllBuilders = state => state.appStates.builders; // Add this selector

export const selectBuilderById = (state, builderId) => state.appStates.builders[builderId]; // Add this selector

export default appStatesSlice.reducer;





